export const OPG_CODES = ['EU-PPP-SP01', 'EU-SP-SBSO'] // UNSUSED
export const CONTRACT_STATUS_VISIBLE_CODE = 'PATSY-P1_VDM'
